var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('router-view')],1),_c('notifications',{attrs:{"position":"bottom right","speed":1200}}),_c('v-overlay',{attrs:{"opacity":1,"value":_vm.loadingPage}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"96"}},[_vm._v(" Loading... ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }